(function () {
    'use strict';

    angular.module('app', [

        // angular modules       
        'ngRoute',
        'ui.bootstrap',
        'ngAnimate',

        // asa modules
        'app.shared.directives',
        'app.shared.services',
        'app.shared.modals',
        // Project Specific
        'app.userlogin'

    ]);

})();
